import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import stripeLogo from './images/powered-by-stripe.svg';
import injectSheet from 'lib/sheet';

const styles = {
  StripeLogo: {
    width: '100%',
    height: 20,
    marginTop: 45,
    background: {
      image: `url("${stripeLogo}")`,
      repeat: 'no-repeat',
      position: 'center',
      size: '103px 17px',
      color: 'transparent',
    },
  },
};

class StripeLogo extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    modifier: PropTypes.string,
  };

  render() {
    const { classes, modifier } = this.props;
    return (
      <div
        className={cx(classes.StripeLogo, modifier)}
      />
    );
  }
}

export default injectSheet(styles)(StripeLogo);
